module.exports = __webpack_public_path__ + "img/ta6.5e81ee1c.png";